'use strict';

export default {
  booking: 'BOOKING',
  subscription: 'SUBSCRIPTION',
};



// WEBPACK FOOTER //
// ./app/src/constants/payment_types.js